'use client'

import { useData } from '@/shared/contexts/DataContext'
import { API_PATHS } from '@/shared/lib/data/paths'
import { useDataStore } from '@/shared/lib/dataStore'
import type { Data } from '@/shared/types/data'

export function useGamificationData(): Data | null {
  const fromStore = useDataStore(s => s.getData())
  const fromContext = useData().getInitialData(API_PATHS.DATA)?.record as
    | Data
    | undefined
  if (fromStore?.version) return fromStore
  return fromContext ?? null
}
